import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Ellipse from './Ellipse';

const EllipseIcon = props => (
    <IconFromPath {...props} Path={Ellipse} />
);

export default EllipseIcon;
